<ng-container *ngIf="{ user: currentUser$ | async, organization: currentOrganization$ | async } as state">
  <div class="chat-icon" *ngIf="chatIconVisible && state.user && state.organization">
    <img src="/assets/media/chat-icon.png" alt="Icon Chat" class="icon" />
  </div>
</ng-container>
